/**
 * `paymentDetails.paymentMethod` — "CARD" | "UPI" — which the booking engine now
 * REQUIRES on hotel rebook and activity change (the engine's Card & UPI fee
 * guide). Without it the engine answers 400 `'paymentDetails.paymentMethod' is
 * required: send "CARD" or "UPI"`, which the modify modals surfaced as
 * "Request failed with status code 400".
 *
 * The portal never offers UPI on a modify, so it sends CARD: a wallet hold
 * carries no fee whatever the method, and the hosted link (Stripe, or a
 * Razorpay link) then offers card only. A valid method the caller already set
 * is kept. Same rule as the traveller app's `withPaymentMethod`.
 */
export const DEFAULT_PAYMENT_METHOD = "CARD";

const PAYMENT_METHODS = ["CARD", "UPI"];

export const withPaymentMethod = (paymentDetails) => {
  const method = String(paymentDetails?.paymentMethod || "").trim().toUpperCase();
  return {
    ...(paymentDetails || {}),
    paymentMethod: PAYMENT_METHODS.includes(method) ? method : DEFAULT_PAYMENT_METHOD,
  };
};
